module.exports = __webpack_public_path__ + "static/media/18ECA15.14863829.jpg";